import * as CompanyTypes from './company.types';
import moment from 'moment';
import {
  IGetCompanyInfoAPIResponseData,
  ISocialMedia,
} from 'api/endpoints/company/company.response.interface';
import { IGetExchangesAPIResponseItem } from 'api/endpoints/general/general.response.interface';
import { ICompanyUpdateFields, IInitialCompanyState } from 'interfaces/company.interface';

export type TcompanyDispatchReducer =
  | {
      type: typeof CompanyTypes.GET_COMPANY_DATA;
      payload: IGetCompanyInfoAPIResponseData;
    }
  | {
      type: typeof CompanyTypes.LOGIN_COMPANY_SUPER_ADMIN;
      payload: IGetCompanyInfoAPIResponseData;
    }
  | {
      type: typeof CompanyTypes.UPDATE_COMPANY_LOGO;
      payload: string;
    }
  | {
      type: typeof CompanyTypes.UPDATE_COMPANY;
      payload: {
        companyData: ICompanyUpdateFields;
        exchanges: IGetExchangesAPIResponseItem[];
      };
    }
  | {
      type: typeof CompanyTypes.ADD_SOCIAL_MEDIA;
      payload: ISocialMedia;
    }
  | {
      type: typeof CompanyTypes.SET_SOCIAL_MEDIA;
      payload: ISocialMedia[];
    }
  | {
      type: typeof CompanyTypes.SET_IS_LOADING;
      payload: boolean;
    };

export default function companyReducer(
  state: IInitialCompanyState,
  action: TcompanyDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    case CompanyTypes.GET_COMPANY_DATA: {
      const loginCompany: IInitialCompanyState = {
        ...state,
        company: {
          ...payload,
          logo: payload?.logo
            ? (`${payload.logo as string}?ts=${moment().unix()}` as string)
            : '',
        },
      };
      return loginCompany;
    }

    case CompanyTypes.LOGIN_COMPANY_SUPER_ADMIN: {
      const loginCompanySuperAdmin: IInitialCompanyState = {
        ...state,
        company: {
          ...state.company,
          ...payload,
        },
      };
      return loginCompanySuperAdmin;
    }

    case CompanyTypes.UPDATE_COMPANY: {
      const updateCompany: IInitialCompanyState = {
        ...state,
        company: {
          ...(state.company as IGetCompanyInfoAPIResponseData),
          ...payload.companyData,
          country: {
            id: payload.companyData.country_id,
            name: payload.companyData.country_name,
            iso_code: payload.companyData.country_iso_code,
          },
          exchange:
            payload.exchanges?.find(
              (exchange) => exchange.id === payload.companyData.currency_id
            ) ?? null,
        },
      };
      return updateCompany;
    }

    case CompanyTypes.UPDATE_COMPANY_LOGO: {
      const updateCompanyLogo: IInitialCompanyState = {
        ...state,
        company: {
          ...(state.company as IGetCompanyInfoAPIResponseData),
          logo: `${payload}?ts=${moment().unix()}` as string,
        },
      };
      return updateCompanyLogo;
    }

    case CompanyTypes.ADD_SOCIAL_MEDIA: {
      const addSocialMedia: IInitialCompanyState = {
        ...state,
        company: {
          ...(state.company as IGetCompanyInfoAPIResponseData),
          tenant_social_media: [
            ...(state.company as IGetCompanyInfoAPIResponseData).tenant_social_media,
            payload,
          ],
        },
      };
      return addSocialMedia;
    }

    case CompanyTypes.SET_SOCIAL_MEDIA: {
      const setSocialMedia: IInitialCompanyState = {
        ...state,
        company: {
          ...(state.company as IGetCompanyInfoAPIResponseData),
          tenant_social_media: payload,
        },
      };
      return setSocialMedia;
    }

    case CompanyTypes.SET_IS_LOADING: {
      const setIsLoading: IInitialCompanyState = {
        ...state,
        isLoading: payload,
      };
      return setIsLoading;
    }

    default:
      return state;
  }
}
